import { createAction } from "@reduxjs/toolkit";
import type { OnboardStudentBody } from "@shared-kernel/application/ports/shared/shared-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const onboardStudent = createApiThunk<void, OnboardStudentBody>(
  "users/onboardStudent",
  async (body, { extra: { sharedRepository } }) => {
    return sharedRepository!.onboardStudent(body);
  },
);

export const resetOnboardStudent = createAction("users/resetOnboardStudent");
